import { CardContainer, CardContent, CardImage } from "./style-component"
import { useNavigate } from "react-router-dom";
import { CardRequiredNFTType } from "./card-required-nft-type";
import { Skeleton, Typography } from "antd";
import ColorThief from "colorthief";
import { useEffect, useState } from "react";

const CardRequiredNFT: React.FC<CardRequiredNFTType> = ({
	thumb_url,
	name,
	token_id,
	children,
	loading = false
}) => {

	const [dominantColor, setDominantColor] = useState<string>("");

	const navigate = useNavigate();
	const handleClick = () => {
		navigate(`/collectible/${token_id}`);
	};

	useEffect(() => {
		const img = new Image();
		img.crossOrigin = "Anonymous";
		img.src = thumb_url;

		img.onload = () => {
			const colorThief = new ColorThief();
			const dominantRGB = colorThief.getColor(img);
			setDominantColor(`rgba(${dominantRGB[0]}, ${dominantRGB[1]}, ${dominantRGB[2]}, 0.5)`);
		};
	}, [thumb_url]);

	if (loading) {
		return (
			<CardContainer>
				<CardImage>
					<Skeleton.Image active={true} />
				</CardImage>
				<CardContent>
					<Skeleton.Input active={true} />
					<Skeleton.Button active={true} />
				</CardContent>
			</CardContainer>
		)
	}

	return (
		<CardContainer
			onClick={handleClick}
			$backgroundColor={dominantColor}
		>
			<CardImage>
				<img
					src={thumb_url}
					alt={name}
				/>
			</CardImage>
			<CardContent>
				<Typography.Text>{name}</Typography.Text>
				{children}
			</CardContent>
		</CardContainer>
	)
}

export default CardRequiredNFT;
